import {Pipe, PipeTransform} from '@angular/core';
import {
    AbbreviatedTravellerXType,
    TravellerXType
} from "../../../../../service/resources/booking/interfaces/get-bookings.enum";
import {BookingType} from "@afidium/ts-facade/model/bookingType";
import {TravellerType} from "@afidium/ts-facade/model/travellerType";

@Pipe({
    name: 'computeTravellerType'
})
export class ComputeTravellerTypePipe implements PipeTransform {

    public transform(signature: string, booking: BookingType, travellers: TravellerType[]): string {
        const travellersToFormat: TravellerType[] = booking ? booking?.travellerArray : travellers;

        const traveller: TravellerType = travellersToFormat?.find((travellerItem: TravellerType): boolean => travellerItem?.signature === signature);
        if (traveller) {
            return traveller.xType;
        }
        return null;
    }
}
